module.exports = __webpack_public_path__ + "img/sks22.4d34bf5d.jpg";